import { motion } from "framer-motion";

const WHATSAPP_NUMBER = "4915129552215";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hallo G-Repair, ich habe eine Frage zu meiner iPhone-Reparatur.")}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="Per WhatsApp kontaktieren"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: 1.2, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)]"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor" aria-hidden="true">
        <path d="M16.004 3C9.374 3 4 8.374 4 15.004c0 2.33.654 4.51 1.785 6.37L4 29l7.82-1.75a11.93 11.93 0 0 0 4.184.754C22.634 28.004 28 22.63 28 15.999 28 9.373 22.634 3 16.004 3zm0 21.56c-1.49 0-2.892-.4-4.102-1.1l-.294-.174-4.64 1.038 1.062-4.53-.192-.3a9.48 9.48 0 0 1-1.49-5.49c0-5.246 4.27-9.516 9.52-9.516 5.247 0 9.516 4.27 9.516 9.516 0 5.246-4.27 9.556-9.48 9.556zm5.224-7.136c-.287-.144-1.697-.84-1.96-.936-.263-.096-.456-.144-.648.144-.192.287-.744.936-.912 1.128-.168.192-.336.216-.623.072-.287-.144-1.212-.447-2.31-1.427-.854-.763-1.43-1.703-1.598-1.99-.168-.287-.018-.442.126-.586.13-.13.287-.335.43-.503.144-.168.192-.287.288-.479.096-.192.048-.36-.024-.504-.072-.144-.648-1.56-.888-2.137-.234-.563-.473-.487-.648-.496l-.552-.01c-.192 0-.504.072-.768.36-.263.287-1.007.984-1.007 2.4s1.031 2.783 1.175 2.975c.144.192 2.03 3.1 4.92 4.347.687.297 1.223.474 1.64.606.689.22 1.316.189 1.812.115.553-.083 1.697-.694 1.937-1.364.24-.67.24-1.244.168-1.364-.072-.12-.263-.192-.55-.336z" />
      </svg>
    </motion.a>
  );
}
